Ext.ns('mx.app.widget');

mx.app.widget.UploadFile = Ext.extend(Ext.Window, {
    modal: true,
    width: 400,
    height: 116,
    layout: 'form',
    constrain: true,
    resizable: false,
    border: false,
    buttonAlign: 'right',
    store: null,
    url: null,
    params: {},
    loadOrders: true,
    loadResources: false,

    labels: {
        windowTitle: 'Import from file',
        selectFile: 'Select a file for upload',
        errorMsg: 'Please, select a file to upload',
        browse: 'Browse...',
        importLabel: 'Import',
        cancel: 'Cancel',
        waitMsg: 'Uploading',
        waitTitle: 'Please Wait...',
    },

    handlers: {
        uploadClick: function() {
            this.findById('file').validate();
            this.formPanel.form.submit({
                scope: this,
                params: this.params,
                url: this.url,
                waitMsg: this.labels.waitMsg,
                waitTitle: this.labels.waitTitle,
                success: function(form, action) {
                    if (this.store) {
                        this.store.reload();
                    }
                    this.close();
                },
                failure: function(form, action) {
                    this.close();
                    if (action.result.error) {
                        mx.Util.displayError(action.result.error);
                    } else if (action.result.message) {
                        mx.Util.displayError(action.result.message);
                    } else {
                        mx.Util.displayError('Server error');
                    }
                },
            });
        },
        cancelClick: function() {
            this.close();
        },
    },

    initComponent: function() {
        this.title = this.labels.windowTitle;

        mx.app.widget.UploadFile.superclass.initComponent.apply(this, arguments);

        this.add(
            (this.formPanel = new Ext.form.FormPanel({
                border: false,
                fileUpload: true,
                bodyStyle: 'padding: 5px;',
                labelAlign: 'top',
                items: [
                    {
                        xtype: 'fileuploadfield',
                        id: 'file',
                        anchor: '-18',
                        allowBlank: false,
                        msgTarget: 'side',
                        fieldLabel: this.labels.selectFile,
                        blankText: this.labels.errorMsg,
                        buttonCfg: {
                            text: this.labels.browse,
                        },
                    },
                ],
            }))
        );

        this.addButton({text: this.labels.importLabel}, this.handlers.uploadClick.createDelegate(this), this);

        this.addButton({text: this.labels.cancel}, this.handlers.cancelClick, this);
    },
});
